import React from "react";
import cx from "classnames";
import { camelCase, upperFirst } from "lodash-es";
// eslint-disable-next-line no-unused-vars
import ReactSelect, {
  components as componentsBase,
  // eslint-disable-next-line no-unused-vars
  Props as ReactSelectProps,
  SelectComponentsConfig,
  OptionTypeBase
} from "react-select";

import styles from "./select.module.scss";
import { Text } from "../Text/Text";

export namespace Select {
  export type Props = {
    error?: boolean;
    minimal?: boolean;
    portal?: boolean;
    width?: number;
    selectRef?: React.RefObject<HTMLInputElement>;
    size?: "xsmall" | "small" | "medium";
    appearance?: "dropdown" | "searchable-input" | "input";
  };
}
/**
 * @deprecated
 * Support for this export has stopped and will
 * be removed entirely in version 2.
 *
 * Please use the "Option" named export instead.
 *
 */
export const SelectComponents = componentsBase;
const { Option: ReactSelectOption } = componentsBase;

/**
 * @todo
 * Add type definitions
 */
export const Option = (props: any): JSX.Element => {
  const { label } = props;
  return (
    <ReactSelectOption {...props}>
      <div>
        <span>{label}</span>
      </div>
    </ReactSelectOption>
  );
};

export function Select<T>({
  appearance = "dropdown",
  className = "",
  error = false,
  minimal = false,
  size = "medium",
  width,
  portal = false,
  openMenuOnFocus = true,
  ...props
}: Select.Props & ReactSelectProps<T>): JSX.Element {
  const customStyles = {
    // Eliminate the default styling on these components
    control: (): object => ({}),
    valueContainer: (): object => ({}),
    input: (): object => ({}),
    dropdownIndicator: (): object => ({}),
    indicatorsContainer: (): object => ({}),
    indicatorSeparator: (): object => ({}),
    indicators: (): object => ({}),
    singleValue: (): object => ({}),
    placeholder: (): object => ({}),
    option: (): object => ({})
  };

  const classList = cx(
    className,
    styles.select,
    styles[`select${upperFirst(camelCase(size))}` as keyof typeof styles],
    styles[
      `selectAppearance${upperFirst(
        camelCase(appearance)
      )}` as keyof typeof styles
    ],
    error && styles.selectError,
    minimal && styles.selectMinimal,
    width && styles.selectInline
  );
  return (
    <div
      className={classList}
      style={width ? { width: `${width}px` } : { width: "auto" }}
    >
      <ReactSelect
        {...props}
        menuPortalTarget={portal ? document.body : null}
        className={styles.selectReactSelect}
        classNamePrefix="react-select"
        styles={customStyles}
        openMenuOnFocus={openMenuOnFocus}
      />
    </div>
  );
}

export function SelectDropdownText(text: string) {
  return (props: any) => {
    const { selectProps } = props;
    if (selectProps.menuIsOpen)
      return (
        <Text weight="bold" theme="primary" style={{ marginRight: "1rem" }}>
          {text}
        </Text>
      );

    return <componentsBase.DropdownIndicator {...props} />;
  };
}
